<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import Request from '@src/mixins/request'
// import CheckinDetail from '@components/checkin-detail'
import CheckinQr from '@components/checkin-qr'
import headers from '@src/data/headers.json'
import { authComputed } from '@state/helpers'

export default {
  metaInfo: {
    title: 'Checkin',
    meta: [{ name: 'description', content: 'Checkin' }],
  },

  $_veeValidate: { validator: 'new' },

  components: { CheckinQr /* CheckinDetail, */ },

  mixins: [Request],

  data() {
    return {
      headers: headers.checkin,
      color: 'gold',
      filter: {
        arrival: format(new Date(), 'YYYY-MM-DD'),
      },
      items: [],
      item: {},
      dialog: false,
      deleteDialog: false,
      qrDialog: false,
      deleteId: null,
    }
  },

  computed: {
    ...authComputed,
    ...mapState('app', {
      propertyId: (state) => state.currentProperty.id,
    }),
    tableHeaders() {
      const th = this.headers.slice(0)
      th.push({ text: 'Actions', sortable: false })
      return th
    },
  },

  watch: {
    qrDialog(val) {
      if (!val) {
        this.item = {}
      }
    },
  },

  mounted() {
    this.fetchItems()
  },

  methods: {
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchItems()
        }
      })
    },
    async fetchItems() {
      const payload = Object.assign(
        { propertyId: this.propertyId },
        this.filter
      )

      const { data } = await this.fetchData({
        url: this.endpoint.checkin.list,
        data: payload,
      })
      this.items = data
    },
    showDetail(item) {
      this.item = item
      this.dialog = true
    },
    showQr(item) {
      this.qrDialog = true
      this.item = item
    },
    editData(item) {
      this.$router.push({ name: 'edit-checkin', params: { id: item.id } })
    },
    async updateItem() {
      await this.fetchItems()
      const x = this.items.find((i) => i.id === this.item.id)
      this.item = x
    },
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    closeDialog() {
      this.deleteDialog = false
      this.deleteId = null
    },
    async onDelete() {
      // console.log(this.endpoint.checkin.delete)
      await this.updateData({
        url: this.endpoint.checkin.delete,
        data: {
          id: this.deleteId,
          propertyId: this.propertyId,
        },
      })
      // console.log('finish update')
      await this.fetchItems()
      // console.log('finish fetch items')
      this.closeDialog()
    },
    can(permission) {
      return this.havePermission(permission)
    },
  },
}
</script>

<template>
  <BaseView title="Check-in" :color="color">
    <!-- Toolbar Extension -->
    <VContainer slot="toolbar-extension" class="px-0" grid-list-xl>
      <VLayout row wrap>
        <VFlex xs12 sm3>
          <BaseDatePicker
            ref="arrival"
            v-model="filter.arrival"
            v-validate="'required|date_format:yyyy-MM-dd'"
            data-vv-name="arrival"
            :error-messages="errors.collect('arrival')"
            :color="color"
            label="Arrival"
          />
        </VFlex>

        <VFlex xs12 sm2>
          <VBtn
            depressed
            :dark="!errors.any()"
            :disabled="errors.any()"
            :color="color"
            @click="onSubmit"
            >Search</VBtn
          >
        </VFlex>
      </VLayout>
    </VContainer>
    <!-- End of Toolbar Extension -->

    <!-- Toolbar Actions -->
    <VBtn
      v-if="isAdmin || can('create-check-in')"
      slot="toolbar-actions"
      :color="color"
      :to="{ name: 'add-checkin' }"
      depressed
      dark
      >Add</VBtn
    >
    <!-- End of Toolbar Actions -->

    <VDataTable
      :headers="headers"
      :loading="loading ? color : false"
      :items="items"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
          <td
            v-for="(header, index) in headers"
            :key="`${header.text}-${index}`"
            :class="{
              'text-xs-right': header.align && header.align === 'right',
            }"
          >
            <template v-if="header.value === 'status'">
              <VChip
                v-if="props.item[header.value] === 'Expected'"
                disabled
                small
                color="red lighten-2"
                text-color="white"
                >{{ props.item[header.value] }}</VChip
              >
              <VChip
                v-if="props.item[header.value] === 'Pre-registered'"
                disabled
                small
                color="green lighten-1"
                text-color="white"
                >{{ props.item[header.value] }}</VChip
              >
              <VChip
                v-if="props.item[header.value] === 'In-house'"
                disabled
                small
                color="gold"
                text-color="white"
                >{{ props.item[header.value] }}</VChip
              >
            </template>
            <template v-else>{{ props.item[header.value] }}</template>
          </td>
        </tr>
      </template>

      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text>
            <VBtn
              v-if="props.item.status === 'Expected'"
              class="ma-0 mr-1"
              color="rgba(0,0,0,.54)"
              flat
              icon
              @click="showQr(props.item)"
            >
              <VIcon small>
                qr_code_2
              </VIcon>
            </VBtn>

            <VBtn
              v-if="
                (isAdmin || can('show-check-in')) &&
                  props.item.status === 'In-house'
              "
              :to="{
                name: 'print-checkin',
                params: { url: $route.params.url, id: props.item.id },
              }"
              class="ma-0 mr-1"
              target="_blank"
              color="rgba(0,0,0,.54)"
              flat
              icon
            >
              <VIcon small>
                print
              </VIcon>
            </VBtn>

            <VBtn
              v-if="isAdmin || can('show-check-in')"
              :to="{
                name: 'view-checkin',
                params: { url: $route.params.url, id: props.item.id },
              }"
              class="ma-0 mr-1"
              color="rgba(0,0,0,.54)"
              flat
              icon
            >
              <VIcon small>
                remove_red_eye
              </VIcon>
            </VBtn>
            <!-- View Icon -->

            <VBtn
              v-if="
                (isAdmin || can('process-check-in')) &&
                  props.item.status === 'Pre-registered'
              "
              :to="{
                name: 'process-checkin',
                params: { url: $route.params.url, id: props.item.id },
              }"
              class="ma-0 mr-1"
              color="rgba(0,0,0,.54)"
              flat
              icon
            >
              <VIcon small>
                login
              </VIcon>
            </VBtn>
            <!-- Check-in Icon -->

            <VBtn
              v-if="
                (isAdmin || can('edit-check-in')) &&
                  props.item.status === 'Expected'
              "
              :to="{ name: 'edit-checkin', params: { id: props.item.id } }"
              class="ma-0 mr-1"
              color="rgba(0,0,0,.54)"
              flat
              icon
            >
              <VIcon small>
                edit
              </VIcon>
            </VBtn>
            <!-- Edit Icon -->

            <VBtn
              v-if="
                (isAdmin || can('delete-check-in')) &&
                  props.item.status === 'Expected'
              "
              class="ma-0"
              color="red lighten-2"
              flat
              icon
              @click="deleteItem(props.item)"
            >
              <VIcon small>
                delete
              </VIcon>
            </VBtn>
          </v-card-text>
        </v-card>
      </template>
    </VDataTable>

    <!-- <CheckinDetail v-model="dialog" :item="item" @roomAssigned="updateItem" /> -->

    <CheckinQr v-model="qrDialog" :item="item" />

    <VDialog v-model="deleteDialog" max-width="290px" persistent>
      <VCard>
        <VCardTitle class="headline">Delete entry</VCardTitle>

        <VCardText>Are you sure want to delete this entry?</VCardText>

        <VCardActions>
          <VSpacer />
          <VBtn color="grey" flat @click="closeDialog">
            Cancel
          </VBtn>

          <VBtn color="gold" flat @click="onDelete">
            Delete
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </BaseView>
</template>
